export const WORKSPACES_LOADED = "workspaces/workspacesLoaded"
export const WORKSPACE_ADDED = "workspaces/workspaceAdded"
export const WORKSPACE_UPDATED = "workspaces/workspaceUpdated"
export const WORKSPACE_DELETED = "workspaces/workspaceDeleted"